var map = {
	"./10-12-2020-v2/1024/img/ao.png": "0625",
	"./10-12-2020-v2/2048/img/ao.png": "4a49",
	"./10-12-2020-v2/512/img/ao.png": "7d97",
	"./10-12-2020-v3/1024/img/ao.png": "14a7",
	"./10-12-2020-v3/2048/img/ao.png": "29de",
	"./10-12-2020-v3/512/img/ao.png": "3e36"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eae8";